import React from "react";
import { BrowserRouter, HashRouter } from "react-router-dom";

import { NotificationProvider } from "./Notification/NotificationContext";
import { WebpushProvider } from "./Notification/WebpushContext";
import MatteroomTabContent from "../features/router/components/MatteroomTabContent";
import { isTeamsApp } from "../constants";

const AppRouter = isTeamsApp ? HashRouter : BrowserRouter;

export const MatteroomTab = () => {
  return (
    <WebpushProvider>
      <NotificationProvider>
        <AppRouter future={{ v7_relativeSplatPath: true }}>
          <MatteroomTabContent />
        </AppRouter>
      </NotificationProvider>
    </WebpushProvider>
  );
};
